<template>
    <div>
        <v-btn-icon
            icon="$oss-edit"
            color="green"
            elevation="0"
            @click="onEditCompanyClick()"
            size="small"
            data-cy="ClientCompaniesEditCompanyBtn-Cta"
            :disabled="disabled"
        />
        <oss-dialog
            v-model="displayCompanyNotAvailableDialog"
            :title="companyNotAvailableDialog.title"
            :valid-title="companyNotAvailableDialog.validText"
            @valid="addAvailableCompany()"
            width="60%"
            data-cy="ClientCompaniesEditCompanyBtn-OssDialog"
        >
            <p>{{ company.name }} {{ companyNotAvailableDialog.message }}</p>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Prop, toNative, Vue } from "vue-facing-decorator";
import USER_ADD_AVAILABLE_COMPANY from "../../graphql/user/UserAddAvailableCompany.gql";

import { User } from "../../store/store";
import { Company } from "../../../../types";
import { updateStoreUser } from "@/services/userServices";

@Component
export class ClientCompaniesEditCompanyBtn extends Vue {
    @Prop({ required: true }) company: Company;
    @Prop({ required: false, default: false }) disabled: Boolean;

    get currentUser(): User {
        return this.$store.state.user;
    }

    displayCompanyNotAvailableDialog = false;

    companyNotAvailableDialog = {
        title: `Attention`,
        message: `n'est pas dans votre liste de sociétés accessibles. Voulez-vous l'ajouter ?`,
        validText: `Ajouter la société`,
    };

    onEditCompanyClick() {
        if (this.currentUser?.profile?.type === "ACCOUNTING") {
            const availableCompany = (this.currentUser.allAvailableCompanies ?? []).find(
                (c) => c.id === this.company.id,
            );

            if (!availableCompany) {
                this.displayCompanyNotAvailableDialog = true;
            } else {
                this.$router.push({ name: "compa", params: { id: this.company.id } });
            }
        }
    }

    async addAvailableCompany() {
        try {
            await this.$apollo.mutate({
                mutation: USER_ADD_AVAILABLE_COMPANY,
                variables: {
                    userId: this.currentUser.id,
                    companyId: this.company.id,
                },
            });
            await updateStoreUser(this.$apollo, this.$store, this.currentUser.id);

            this.$router.push({ name: "compa", params: { id: this.company.id } });
        } catch (error) {
            console.log(error);
        }
    }
}

export default toNative(ClientCompaniesEditCompanyBtn);
</script>
